import React, { useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import "./PlatinumProgramSignUpResult.scss";
import { useAuth } from "../../../contexts/Auth";
import { connect } from "react-redux";
import { addUserSettingsLoad } from "../../../appRedux/ducks/userSettings";

const PlatinumProgramSignUpResult = ({ userSettings, setUserSettings }) => {
  const { canSeeInternal, loading } = useAuth();
  useEffect(() => {
    if (!loading) {
      setUserSettings({
        ...userSettings,
        platinum_sign_up: true,
        om_platinum_sign_up: true,
      });
    }
  }, [loading]);
  return (
    <div className="platinum-program-sign-up-result">
      {!loading ? (
        <React.Fragment>
          <div className="platinum-program-sign-up-result-left-part">
            <div className="platinum-program-sign-up-result-icon-wrapper">
              <svg
                width="200"
                height="200"
                viewBox="0 0 200 200"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_978_14747)">
                  <path
                    d="M99.998 0C44.7705 0 0 44.7705 0 99.998C0 155.226 44.7705 199.996 99.998 199.996C155.226 199.996 199.996 155.226 199.996 99.998C199.996 44.7705 155.226 0 99.998 0ZM99.998 187.46C51.695 187.46 12.5359 148.301 12.5359 99.998C12.5359 51.695 51.695 12.5398 99.998 12.5398C148.301 12.5398 187.46 51.6989 187.46 100.002C187.46 148.305 148.301 187.464 99.998 187.464V187.46Z"
                    fill="url(#paint0_linear_978_14747)"
                  />
                  <path
                    d="M151.729 61.281C149.525 59.0693 147.239 56.9357 145.136 54.634C144.105 53.5086 143.331 53.6962 142.444 54.5871C137.407 59.6554 132.382 64.7354 127.356 69.8115C125.746 71.2691 124.261 72.8634 122.714 74.3874C112.999 83.9535 103.39 93.629 93.75 103.269C85.8525 111.163 77.9277 119.029 70.0889 126.977C68.8501 128.232 68.1663 128.13 66.9901 126.93C60.6088 120.428 54.1376 114.012 47.7173 107.544C47.0569 106.88 46.6857 106.497 45.7361 107.341C43.2664 109.549 40.9257 111.858 38.7374 114.344C37.991 115.192 38.163 115.536 38.7687 116.352C39.7925 117.724 41.0312 118.853 42.227 120.029C47.1429 124.848 51.8907 129.83 56.9395 134.523C59.0027 136.442 60.7964 138.72 62.8674 140.666C66.7165 144.284 69.6317 145.215 73.43 141.463C92.1791 122.937 110.745 104.223 129.365 85.5635C134.187 80.7296 138.978 75.8606 143.78 71.0073C146.512 68.3227 149.212 65.6107 151.99 62.973C152.858 62.1524 152.217 61.7695 151.732 61.2849L151.729 61.281Z"
                    fill="url(#paint1_linear_978_14747)"
                  />
                </g>
                <defs>
                  <linearGradient
                    id="paint0_linear_978_14747"
                    x1="199.996"
                    y1="-0.00104484"
                    x2="-1.76509"
                    y2="1.79575"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#5EEECD" />
                    <stop offset="1" stopColor="#007BFF" />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_978_14747"
                    x1="152.418"
                    y1="53.853"
                    x2="37.2411"
                    y2="55.1541"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#5EEECD" />
                    <stop offset="1" stopColor="#007BFF" />
                  </linearGradient>
                  <clipPath id="clip0_978_14747">
                    <rect width="200" height="200" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>

            <div className="platinum-program-sign-up-result-success-title">
              Thank You For Signing Up!
            </div>

            <div className="platinum-program-sign-up-result-success-info">
              This is your official confirmation.
              <br />
              Thanks for joining the Platinum Program. Check back in the next 12
              hours to access the features fully. Say goodbye to uncertainty and
              hello to consistent profits with the Plantinum Program.
            </div>

            {!!canSeeInternal && (
              <Link to="/home/Intraday/Auto/Up">
                <Button className="back-to-dashboard">Back to Dashboard</Button>
              </Link>
            )}
          </div>
          <div className="platinum-program-sign-up-result-right-part">
            <div className="platinum-program-big-title">
              Get the Inside Scoop on Earnings Surprises Before Everyone Else.
            </div>
            <div className="platinum-program-small-title">
              Hey there, tired of feeling lost in the options market and not
              making any gains? Well, check out our awesome new option trading
              program! It&apos;s designed to give you an advantage in the
              options market.
              <br />
              <br />
              Our system will teach you how to make profits consistently by
              recognizing market trends and spotting those sweet
              high-probability trades. And the best part? Our step-by-step
              approach makes options trading a breeze! no more stress, just
              financial success. So, what are you waiting for? Let&apos;s start
              trading!
              <br />
              <br />
              Whether you&apos;re a beginner or an experienced trader, the
              Platinum Program is the solution you&apos;ve been searching for.
              Say goodbye to uncertainty and hello to consistent profits with
              the Platinum Program.
            </div>

            <div className="platinum-program-big-title">Key Benefits</div>
            <div className="platinum-program-color-title">
              What You Will Learn:
            </div>
            <div className="platinum-program-ul">
              <li className="platinum-program-li">
                <span>Comprehensive training program</span>
              </li>
              <li className="platinum-program-li">
                <span>
                  Daily live streams with Platinum trading expert Eric
                  Armenteros.
                </span>
              </li>
              <li className="platinum-program-li">
                <span>
                  Daily Live Q&A section for clarifying doubts and getting
                  answers to questions
                </span>
              </li>
              <li className="platinum-program-li">
                <span>
                  Daily trade alerts for valuable insights and recommendations
                </span>
              </li>
              <li className="platinum-program-li">
                <span>
                  Step-by-step approach to options trading that takes the
                  guesswork out of the process
                </span>
              </li>
              <li className="platinum-program-li">
                <span>
                  Opportunities to learn from a seasoned options trader in
                  real-time
                </span>
              </li>
              <li className="platinum-program-li">
                <span>
                  Access to a supportive community of like-minded traders
                </span>
              </li>
              <li className="platinum-program-li">
                <span>
                  Improved understanding of market trends and high-probability
                  trade opportunities
                </span>
              </li>
              <li className="platinum-program-li">
                <span>
                  Increased confidence and consistency in options trading
                </span>
              </li>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div className="platinum-program-sign-up-center-element">
          <div className="platinum-program-sign-up-result-icon-wrapper">
            <CircularProgress size={200} color="success" />
          </div>
          <div className="platinum-program-sign-up-result-loading-text">
            You&apos;re one step closer to trading success! We&apos;re
            processing your account creation.
          </div>
        </div>
      )}
    </div>
  );
};

const stateToProps = (state) => ({
  userSettings: state.userSettings.userSettings,
});

const dispatchToProps = (dispatch) => ({
  setUserSettings: (settings, firstRender) =>
    dispatch(addUserSettingsLoad(settings, firstRender)),
});

export default connect(
  stateToProps,
  dispatchToProps,
)(PlatinumProgramSignUpResult);
